import moment from 'moment'

export const toLocalTimestampStr = (timestamp?: string, format = 'DD/MM/YY HH:mm') => {
  if (!timestamp) {
    return '-'
  }

  return moment.utc(timestamp).local().format(format)
}
